export { getProfessionalSelectionSearchServiceList } from './getProfessionalSelectionSearchServiceList'



// WEBPACK FOOTER //
// ./src/services/nursingHome/professionalSelection/professionalSelectionSearch/index.ts